import { render, staticRenderFns } from "./accountsDeposit.vue?vue&type=template&id=149a9b2a"
import script from "./accountsDeposit.vue?vue&type=script&lang=js"
export * from "./accountsDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports